<template>
  <exo-table :root="currentRoot" :eagerForm="true">
    <exo-form :root="currentRoot">
      <CustomEvasiveScenarioForm v-on:mounted="changeRoot($event)" />
    </exo-form>
  </exo-table>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import CustomEvasiveScenarioForm from './CustomEvasiveScenarioForm'

export default {
  name: 'CustomEvasiveScenario',

  components: { CustomEvasiveScenarioForm },

  mixins: [formMixin, numericalMixin],

  computed: {},
  watch: {},

  data() {
    return { currentRoot: this, enableFormCache: false }
  },

  methods: {
    getCurrentFormType() {
      return 'CustomEvasiveScenarioDefinition'
    },
    changeRoot(root) {
      this.currentRoot = root
    }
  }
}
</script>
